export default __webpack_public_path__ + "static/media/notification_hover.5be610f4.svg";